<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Role" subTitle="Forms" />

    <CreateRoleGroup />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateRoleGroup from "@/components/Pages/Master/RoleGroup/CreateRoleGroup.vue";

export default defineComponent({
  name: "CreateRoleGroupPage",
  components: {
    PageTitle,
    CreateRoleGroup,
  },
});
</script>
